<template>
    <v-container fluid class="bg-main">
        <v-layout row>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        Danh Sách Vip Like Instagram:
                        <v-text-field
                            v-model="search"
                            outlined
                            append-icon="search"
                            label="Tìm theo Tên"
                            hide-details
                            style="max-width: 320px; margin-left: 40%"
                        ></v-text-field>

                        <div class="float-right div-icon-action">
                            <v-icon @click="print" >mdi-printer</v-icon>
                        </div>
                        <div class="float-right div-icon-action ml-0">
                            <export-excel  :data   = "desserts">
                                <v-icon>mdi-file-export</v-icon>
                            </export-excel>
                        </div>
                    </v-card-title>
                    <div id="fb-post-activity-log">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                        >
                            <template v-slot:item.uid = "{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.link" target="_blank">{{ item.uid }}</a>
                                </v-layout>
                            </template>
                            <template v-slot:item.prices = "{item}">
                                <span>{{ item.prices | currency_init }}</span>
                            </template>

                            <!--Status-->
                            <template v-slot:item.status="{ item }">
                                <v-chip v-if="item.status == 1" color="orange" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-sync</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 2" color="success" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-check</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 3" color="secondary" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-close-circle</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 4" color="danger" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-cancel</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                            </template>
                            <!--Status-->

                            <!--Icon cancel-->
                            <template v-slot:item.action="{item}">
                              <v-btn depressed small color="primary" @click="openDialogExtendDate(item)"  v-if="item.status == 1">
                                Gia hạn
                              </v-btn>
                              <v-btn class="ml-1" depressed small color="secondary" @click="checkJobDone(item.id)"  v-if="item.status == 1">
                                Hoàn thành
                              </v-btn>
                            </template>
                            <!--Icon cancel-->
                        </v-data-table>
                    </div>

                    <div id="fb-post-activity-log-print">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                                disable-pagination
                                hide-default-footer
                        >

                        </v-data-table>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
      <v-dialog v-model="dialogUpdateOrder"
                max-width="1200px"
      >
        <v-card elevation="4">
          <v-card-title style="background-color: rgb(66, 103, 178); border-color: rgb(66, 103, 178); color: white">
            <span class="headline">Gia hạn Job</span>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-form
                  class="mt-3"
                  ref="form_update_order"
                  lazy-validation
              >
                <v-layout row>
                  <v-flex md3 class="mt-4">
                    <label class="text-color">Tên tài khoản:</label>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                        solo
                        v-model="name"
                        disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout align-center row>
                  <v-flex md6>
                    <v-flex md12>
                      <label class="text-color">Số lượng like nhỏ nhất cần tăng mỗi bài viết:</label>
                    </v-flex>
                    <v-flex md10>
                      <v-text-field
                          solo
                          v-model="amountMin"
                          type="number"
                          :min="minMin"
                          required
                      ></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex md6>
                    <v-flex md12>
                      <label class="text-color">Số lượng like lớn nhất cần tăng mỗi bài viết</label>
                    </v-flex>
                    <v-flex md10>
                      <v-text-field
                          solo
                          v-model="amountMax"
                          type="number"
                          :min="amountMin"
                          required
                      ></v-text-field>
                    </v-flex>

                  </v-flex>
                </v-layout>
                <v-layout align-center row>
                  <v-flex md6>
                    <v-flex md12>
                      <label class="text-color">Số lượng bài viết cần tăng trong 1 ngày:</label>
                    </v-flex>
                    <v-flex md10>
                      <v-text-field
                          solo
                          v-model="noPostDay"
                          type="number"
                          required
                      ></v-text-field>
                    </v-flex>
                  </v-flex>
                  <v-flex md6>
                    <v-flex md12>
                      <label class="text-color">Số ngày gia hạn:</label>
                    </v-flex>
                    <v-flex md10>
                      <v-text-field
                          solo
                          v-model="noDay"
                          type="number"
                          required
                      ></v-text-field>
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex md3 class="mt-4">
                    <label class="text-color">Giá tiền mỗi tương tác:</label>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                        solo
                        disabled
                        v-model="price"
                        type="number"
                        :min="priceMin"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row class="pa-0 mb-4">
                  <v-flex md3>
                    <label class="text-color">Ghi chú</label>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                        solo
                        v-model="notes"
                        placeholder="Thêm ghi chú người dùng (có thể để trống)"
                        required
                        hide-details="auto"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout align-center row class="mt-2">
                  <v-flex md11>
                    <v-card :color="COLOR.VIP" height="120px">
                      <v-card-title>
                        <div class="div-total" style="color: white">
                          <p>
                            Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                            Bạn sẽ mua vip <strong>{{amountMax}}</strong> Like trong <strong>{{ noDay
                            }}</strong> Ngày với giá <strong class="">{{price | currency_init}}</strong> {{
                            priceUnit}}
                          </p>
                        </div>

                      </v-card-title>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center">
            <v-btn depressed @click="dialogUpdateOrder = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" style="color: white" depressed @click="updateJob()">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>

<script>
    import {
        VIP_FACE_LIST,
        VIP_CANCEL_ORDER,
        VIP_LIKE_MONTH_INSTAGRAM_UPDATE_PROCESS,
        VIP_FACE_GET_SEEDING,
        VIP_LIKE_MONTH_INSTAGRAM_SUCCESS_ORDER,
        VIP_INSTAGRAM_CALCULATE
    } from "../../store/actions.type";
    import Swal from "sweetalert2";
    import {COLOR} from "~/config/constant";
    import {COMMON_SET_LOADING} from "../../store/mutations.type";
    // import Swal from 'sweetalert2';

    export default {
        data () {
            return {
                dialog: false,
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                COLOR: COLOR,
                headers: [
                    { text: '#', value: 'id', align: "center"},
                    { text: 'Username', value: 'username', align: "center"},
                    { text: 'Uid', value: 'uid'},
                    { text: 'Name', value: 'name', align: "center" },
                    { text: 'Min Like', value: 'min_like', align: "center"  },
                    { text: 'Max Like', value: 'max_like', align: "center"  },
                    { text: 'Số Ngày', value: 'days', align: "center"  },
                    { text: 'Tổng Tiền', value: 'prices', align: "center"  },
                    { text: 'Hết Hạn', value: 'end_at', align: "center"  },
                    { text: 'Khởi Tạo', value: 'start_at', align: "center"  },
                    { text: 'Ghi Chú', value: 'note', align: "center"  },
                    {text: 'Trạng thái', value: 'status', align: "center"},
                    {text: 'Hành động', value: 'action', align: "center", width: '300px'}
                ],
                dialogUpdateOrder : false,
                currentOrder : {},

                // Gia tien
                price: 70,
                priceUnit: '  coin/ 1 like/ 1 tháng',
                priceMin: 70,
                // Ghi chu
                notes: "",

                // Tong so coin
                totalCoin: 210000,
                totalAmount: 50,

                // amount
                amountMin: 50,
                amountMax: 50,
                name : '',
                minMin: 40,
                noPostDay: 1,
                noDay : 1,
                item_id : '',
                search : '',
            }
        },
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
            amountMax () {
                this.calculate()
            },
            noPostDay () {
                this.calculate()
            },
            noDay () {
                this.calculate()
            },
            search() {
                this.options.page = 1;
                this.getDataFromApi()
                    .then(data => {
                        this.desserts = data.items;
                        this.totalDesserts = data.total;
                    });

            }
        },
        created () {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items
                    this.totalDesserts = data.total
                });
            this.customDataFromApi()
        },
        methods: {
            async getDataFromApi () {
                this.loading = true
                const { sortBy, sortDesc, page, itemsPerPage } = this.options

                let items =  await this.$store.dispatch(VIP_FACE_LIST, {"api_route": "instagram-vip/vip-like-month", 'search' : this.search });
                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }
                this.loading = false;
                return {items,total};

            },
            print() {
                this.$htmlToPaper("fb-post-activity-log-print");
            },

            checkJobDone(id) {
                this.desserts.forEach(item => {
                    if (item.id === id) {
                        this.coin_cancel_order = item.coin_cancel_order;
                    }
                })

                Swal.fire({
                    title: 'Bạn có thực sự muốn hoàn thành job?',
                    text: `Sau khi hoàn thành bạn sẽ có thể tạo thêm job mới!`,
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Hoàn thành job',
                    cancelButtonText: 'Quay lại'
                }).then(async (result) => {
                    if (result.value) {
                        await this.$store.dispatch(VIP_LIKE_MONTH_INSTAGRAM_SUCCESS_ORDER, id);
                        let desserts = [...this.desserts];
                        desserts.forEach(item => {
                            if (item.id === id) {
                                item.status = 2;
                                item.status_name = "Thành công";
                            }
                        });
                        this.desserts = [...desserts];
                        Swal.fire(
                            'Đã hoàn thành!',
                            'Job của bạn đã được hoàn thành',
                            'success'
                        )
                    }
                })
            },

            editJob(id) {
                this.desserts.forEach(item => {
                    if (item.id === id) {
                        this.num_seeding_post = item.num_seeding_need;
                    }
                });
                Swal.fire({
                    title: 'Chỉnh sửa số lượng tăng',
                    input: 'text',
                    showCancelButton: true,
                    inputValue: this.num_seeding_post,
                }).then(
                    result => {
                        if (result.value < this.num_seeding_post) {
                            Swal.fire({
                                type: 'error',
                                icon: 'warning',
                                text: "Bạn không được nhập số lượng seeding thấp hơn số lượng ban đầu"
                            })
                        } else {
                            let desserts = [...this.desserts];
                            desserts.forEach(item => {
                                if (item.id === id) {
                                    item.num_seeding_need = result.value;
                                }
                            });
                            this.desserts = [...desserts];
                            Swal.fire({
                                type: 'success',
                                icon: 'success',
                                text: "Bạn đã thay đổi thành công số lượng ban đầu"
                            })
                        }
                    }
                );
            },
            fetchDataFromApi(id) {
                this.$store.dispatch(VIP_CANCEL_ORDER, id).then(resp => {
                    let desserts = [...this.desserts];
                    desserts.forEach(item => {
                        if (item.id === id) {
                            item.num_seeding_gain = resp.num_seeding_gain;
                        }
                    });
                    this.desserts = [...desserts];
                });
            },
            //cancel job
            async cancelOrder(id, cancel_order_coin) {
                Swal.fire({
                    title: 'Bạn có thực sự muốn hủy?',
                    text: `Sau khi hủy bạn sẽ được hoàn lại số tiền tương ứng với số lượng chưa được tăng và trừ thêm ${cancel_order_coin} coin phí để tránh Spam !`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Hủy job',
                    cancelButtonText: 'Quay lại'
                }).then(async (result) => {
                    if (result.value) {
                        await this.$store.dispatch(VIP_CANCEL_ORDER, id);
                        let desserts = [...this.desserts];
                        desserts.forEach(item => {
                            if (item.id === id) {
                                item.status = 4;
                                item.status_name = "Hủy bỏ";
                            }
                        });
                        this.desserts = [...desserts];
                        Swal.fire(
                            'Đã hủy!',
                            'Job của bạn đã hủy thành công',
                            'success'
                        )
                    }
                })
            },
            openDialogExtendDate (item) {
                this.currentOrder = item
                this.dialogUpdateOrder = true
                this.amountMax = item.max_like
                this.amountMin = item.min_like
                this.noPostDay = item.max_post_daily
                this.name = item.name
                this.notes = item.note
                this.price = item.fix_coin
                this.calculate();
            },

            validateForm () {
                let check = this.$refs.form_update_order.validate()
                let message = 'Thông tin điền đang chưa chính xác'
                if (this.amountMin === '') {
                    return {check: false, message: "Chưa Nhập số lượng like nhỏ nhất"};
                }
                if (this.amountMax === '') {
                    return {check: false, message: "Chưa Nhập số lượng like lớn nhất"};
                }

                if (parseInt(this.amountMin) > parseInt(this.amountMax)) {
                    return {check: false, message: "Số lượng like nhỏ nhất phải nhỏ hơn số lượng lớn nhất"};
                }
                if (this.noPostDay < 1) {
                    return {check: false, message: "Số lượng bài viết cần tăng trong 1 ngày không hợp hệ"};
                }
                if (this.noDay < 1) {
                    return {check: false, message: "Số ngày gia hạn không hợp hệ"};
                }

                return { check: check, message: message }
            },

            getParams () {
                let formData = new FormData()
                formData.append('id', this.currentOrder.id)
                formData.append('max_like', this.amountMax)
                formData.append('min_like', this.amountMin)
                formData.append('max_post_daily', this.noPostDay)
                formData.append('days', this.noDay)
                formData.append('note', this.notes)
                return formData
            },

            async updateJob () {
                let validateForm = this.validateForm()
                if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: 'Bạn có chắc chắn muốn update order ',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then(async (result) => {
                            if (result.value) {
                                this.overlay = true
                                this.$store.commit(COMMON_SET_LOADING, true)
                                await this.$store.dispatch(VIP_LIKE_MONTH_INSTAGRAM_UPDATE_PROCESS, this.getParams())
                                this.$store.commit(COMMON_SET_LOADING, false)
                                this.dialogUpdateOrder = false
                                this.getDataFromApi()
                                    .then(data => {
                                        this.desserts = data.items
                                        this.totalDesserts = data.total
                                    });
                            }
                        })
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },

            async calculate () {
                let param = {
                    seeding_type: 25,
                    max_like: this.amountMax,
                    days: this.noDay,
                    fix_coin_job: this.price,
                    max_post_daily: this.noPostDay,
                    id : this.currentOrder.id
                };
                let rs = await this.$store.dispatch(VIP_INSTAGRAM_CALCULATE, param);
                if (rs) {
                    this.totalCoin = rs;
                }
            },

            async customDataFromApi() {
                let data = await this.$store.dispatch(VIP_FACE_GET_SEEDING, {seeding_type_id: 25});
                if (data) {
                    this.priceMin = data.fix_coin
                    if (data.video) {
                        let videoId = this.youtube_parser(data.video);
                        if (videoId) {
                            this.videoId = videoId;
                        }
                    }
                }
            },
        },
    }
</script>
<style lang="scss">
    .div-icon-action{
        i {
            cursor: pointer;
        }
    }
    .a-post-link {
        text-decoration: none;
    }
    #fb-post-activity-log-print {
        display: none;
    }
</style>
